import _ from "lodash";

//Check renewability
export const checkRenewabilityLoading = (onlineRenewalReq) =>
  _.get(onlineRenewalReq, ["checkRenewal", "loading"], false);
export const checkRenewabilityData = (onlineRenewalReq) =>
  _.get(onlineRenewalReq, ["checkRenewal", "items"], null);
export const checkRenewabilityStatus = (onlineRenewalReq) =>
  _.get(onlineRenewalReq, ["checkRenewal", "status"], false);
  export const checkRenewabilityDataCoveragePeriod = (item) => _.get(item, ["CoveragePeriod"], null);
  export const checkRenewabilityDataMessage = (item) => _.get(item, ["Message"], null);
  export const checkRenewabilityDataNric = (item) => _.get(item, ["Nric"], null);
  export const checkRenewabilityDataOrderNumber = (item) => _.get(item, ["OrderNumber"], null);
  export const checkRenewabilityDataPolicyNumber = (item) => _.get(item, ["PolicyNumber"], null);
  export const checkRenewabilityDataPremium = (item) => _.get(item, ["Premium"], null);
  export const checkRenewabilityDataProduct = (item) => _.get(item, ["Product"], null);
  export const checkRenewabilityDataRedirectUrl = (item) => _.get(item, ["RedirectUrl"], null);
  export const checkRenewabilityDataRenewable = (item) => _.get(item, ["Renewable"], null);
  export const checkRenewabilityDataRepurchaseLapsed = (item) => _.get(item, ["RepurchaseLapsed"], null);
  export const checkRenewabilityDataShowRecurringPaymentCheckBox = (item) => _.get(item, ["ShowRecurringPaymentCheckBox"], null);
  export const checkRenewabilityDataStatusLabel = (item) => _.get(item, ["StatusLabel"], null);
  export const checkRenewabilityDataTiqHome = (item) => _.get(item, ["TiqHome"], null);
  export const checkRenewabilityDataIsTiqHome = (item) => _.get(item, ["isTiqHome"], null);
  export const checkRenewabilityDataTiqHomeUrl = (item) => _.get(item, ["TiqHomeUrl"], null);
  export const checkRenewabilityDataIsRecurring = (item) => _.get(item, ["isRecurring"], null);
  export const checkRenewabilityDataRenewabilityStatus = (item) => _.get(item, ["RenewabilityStatus"], null);
  export const checkRenewabilityDataIsEddaRenewalAllow = (item) => _.get(item, ["IsEddaRenewalAllow"], null);
  export const checkRenewabilityDataOwnerName = (item) => _.get(item, ["OwnerName"], null);


//renewal PayNow
export const renewalPayNowLoading = (onlineRenewalReq) =>
_.get(onlineRenewalReq, ["renewalPayNow", "loading"], false);
export const renewalPayNowData = (onlineRenewalReq) =>
_.get(onlineRenewalReq, ["renewalPayNow", "items"], null);
export const renewalPayNowStatus = (onlineRenewalReq) =>
_.get(onlineRenewalReq, ["renewalPayNow", "status"], false);
export const renewalPayNowDataPaymentModel = (item) => _.get(item, ["PaymentModel"], null);
export const renewalPayNowDataAPIName = (item) => _.get(item, ["APIName"], null);
export const renewalPayNowDataAmount = (item) => _.get(item, ["amount"], null);
export const renewalPayNowDataEmail = (item) => _.get(item, ["email"], null);
export const renewalPayNowDataIsRecurring = (item) => _.get(item, ["isRecurring"], null);
export const renewalPayNowDataKey = (item) => _.get(item, ["key"], null);
export const renewalPayNowDataNotifyURL = (item) => _.get(item, ["notifyURL"], null);
export const renewalPayNowDataPayMode = (item) => _.get(item, ["payMode"], null);
export const renewalPayNowDataReturnURL = (item) => _.get(item, ["returnURL"], null);
export const renewalPayNowDataTxnId = (item) => _.get(item, ["txnId"], null);
export const renewalPayNowDataPaymentUrl = (item) => _.get(item, ["PaymentUrl"], null);


//renewal status message
export const getStatusMsgLoading = (onlineRenewalReq) =>
_.get(onlineRenewalReq, ["getStatusMsg", "loading"], false);
export const getStatusMsgData = (onlineRenewalReq) =>
_.get(onlineRenewalReq, ["getStatusMsg", "items"], null);
export const getStatusMsgStatus = (onlineRenewalReq) =>
_.get(onlineRenewalReq, ["getStatusMsg", "status"], false);
export const getStatusMsgDataStatus = (item) => _.get(item, ["Status"], null);
export const getStatusMsgDataSuccess = (item) => _.get(item, ["Success"], null);
export const getStatusMsgDataData = (item) => _.get(item, ["Data"], null);
export const getStatusMsgDataLabel = (item) => _.get(item, ["Label"], null);
export const getStatusMsgDataLoginPortalLink = (item) => _.get(item, ["Login_Portal_Link"], null);
export const getStatusMsgDataMobile = (item) => _.get(item, ["Mobile"], null);
export const getStatusMsgDataOnlineRenewalLink = (item) => _.get(item, ["Online_Renewal_Link"], null);
export const getStatusMsgDataStatusMessage = (item) => _.get(item, ["Status_Message"], null);
export const getStatusMsgDataSurveyLink = (item) => _.get(item, ["Survey_Link"], null);
export const getStatusMsgDataEmail = (item) => _.get(item, ["Email"], null);

// Renewal Tiq Home
export const renewalTiqHomeLoading = (onlineRenewalReq) =>
  _.get(onlineRenewalReq, ["renewalTiqHome", "loading"], false);
export const renewalTiqHomeData = (onlineRenewalReq) =>
  _.get(onlineRenewalReq, ["renewalTiqHome", "items"], null);
export const renewalTiqHomeStatus = (onlineRenewalReq) =>
  _.get(onlineRenewalReq, ["renewalTiqHome", "status"], false);
